export default {
    props : {
        name : {type: String, required: false},
        errors : {type: Object, required: false},
        label : {type: String, required: false},
        preventEnter : {type: Boolean, required: false, default: false},
        modelValue : {required: false},
        disabled: {required: false, type: Boolean, default: false}
    },
    emits: ['update:modelValue'],
    computed: {
        form_errors() {
            if(this.errors){
                return this.errors;
            }
            return [];
        }
    },
    methods:{
        hasError(){
            return typeof this.form_errors[this.name] != 'undefined';
        },
        feedbackHtml(){
            //Return the errors html based on bootstrap4 validation if exists
            if(typeof this.form_errors[this.name] != 'undefined'){
                let outputHtml = '';
                for(let error in this.form_errors[this.name]){
                    outputHtml+= '<div class="invalid-feedback">'+this.form_errors[this.name][error]+'</div>';
                }
                return outputHtml;
            }
            return '';
        },
        handlePreventEnter(event){
            if(this.preventEnter && event.key==='Enter'){
                event.preventDefault();
            }
        }
    }
}
